import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import { ILegalClientFullObject } from '../Interfaces/ILegalClient';
import { ILegalClientType } from '../Interfaces/ILegalClientType';

type IProps = {
  formValues: ILegalClientFullObject;
  legalClientTypes: ILegalClientType[];
  setFormValues: Dispatch<SetStateAction<ILegalClientFullObject>>;
};

export const LegalClientTypeForm = ({
  formValues,
  legalClientTypes,
  setFormValues,
}: IProps) => {
  return (
    <FormControl fullWidth size='small'>
      <InputLabel id='legal-client-type-label'>Typ</InputLabel>
      <Select
        labelId='legal-client-type-label'
        label='Typ'
        value={formValues.idLegalClientType}
        onChange={event => {
          const newTypeId = Number(event.target.value);
          setFormValues((prev: ILegalClientFullObject) => ({
            ...prev,
            idLegalClientType: newTypeId,

            LegalClientType: legalClientTypes.find(
              type => type.idLegalClientType === newTypeId
            )!.LegalClientType,
            FirstName: '',
            LastName: '',
            idGender: 4,
            idBusinessForm:
              newTypeId === 1
                ? 1
                : prev.idBusinessForm === 1
                  ? 2
                  : prev.idBusinessForm,
          }));
        }}
      >
        {legalClientTypes.map((type, i) => (
          <MenuItem key={i} value={type.idLegalClientType}>
            {type.LegalClientType}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
